module.exports = __webpack_public_path__ + "img/pantalla 5-4.b9760f53.svg";